import React from 'react';
import { TFunction } from 'i18next';
import { Box, Collapse, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import {
	BufferTime,
	BufferTimeDirection,
	EMPTY_FIXED_BUFFER_TIME,
	EMPTY_RELATIVE_BUFFER_TIME,
} from 'common/modules/atoms/bufferTimes';
import FixedBufferTimePicker from './FixedBufferTimePicker';
import RelativeBufferTimePicker from './RelativeBufferTimePicker';
import { DateFormatObject } from 'common/types';

export interface BufferTimePickerProps {
	value?: BufferTime;
	onChange?: (value: BufferTime) => void;
	disabled?: boolean;
	direction?: BufferTimeDirection;
	dateFormat: DateFormatObject;
	t: TFunction;
}
const BufferTimePicker = (props: BufferTimePickerProps) => {
	const { value = EMPTY_FIXED_BUFFER_TIME, onChange, direction, dateFormat, t } = props;

	const handleTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.value === 'fixed') {
			onChange?.(EMPTY_FIXED_BUFFER_TIME);
		}
		if (e.target.value === 'relative') {
			onChange?.(EMPTY_RELATIVE_BUFFER_TIME);
		}
	};

	return (
		<RadioGroup value={value.type} onChange={handleTypeChange}>
			<FormControlLabel
				value="fixed"
				control={<Radio color="primary" />}
				label={
					<Typography>
						{direction === 'after'
							? t('common:times.fixedAmountOfTimeAfter', 'Fixed amount of time after')
							: t('common:times.fixedAmountOfTimeBefore', 'Fixed amount of time before')}
					</Typography>
				}
			/>
			<Collapse in={value.type === 'fixed'}>
				<Box mb={2} ml={4}>
					<FixedBufferTimePicker
						value={value.type === 'fixed' ? value.value : undefined}
						onChange={(value) => onChange?.({ type: 'fixed', value })}
						disabled={value.type !== 'fixed'}
						t={t}
					/>
				</Box>
			</Collapse>
			<FormControlLabel
				value="relative"
				control={<Radio color="primary" />}
				label={<Typography>{t('common:times.byTimeOfDay', 'By time of day')}</Typography>}
			/>
			<Collapse in={value.type === 'relative'}>
				<Box mb={2} ml={4}>
					<RelativeBufferTimePicker
						value={value.type === 'relative' ? value.value : undefined}
						onChange={(value) => onChange?.({ type: 'relative', value })}
						disabled={value.type !== 'relative'}
						direction={direction}
						dateFormat={dateFormat}
						t={t}
					/>
				</Box>
			</Collapse>
		</RadioGroup>
	);
};

export default BufferTimePicker;
